import React, {
  useState,
  useEffect,
} from 'react';

import {
  Exercise,
} from '@gymcloud/core';

import {
  Icon,
  Popup,
  Tooltip,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

type Props = {
  readOnly: boolean,
  exercise: Exercise,

  onAdd: { (exerciseId: number): void },
  onSet: { (exerciseId: number, alternativeId: number): void },
  onRemove: { (exercise: any): void },
};

const Alternatives = ({
  readOnly,
  exercise,
  onAdd,
  onSet,
  onRemove,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstTooltipIsOpen, setFirstTooltipIsOpen] = useState(false);

  useEffect(() => {
    if (!readOnly && exercise.hasFirstAlternative) {
      setFirstTooltipIsOpen(true);
      const timer = setTimeout(() => {
        setFirstTooltipIsOpen(false);
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }

    return () => {};
  }, [readOnly, exercise.hasFirstAlternative]);

  if (!exercise.alternatives.length) return null;

  const tooltipProps = firstTooltipIsOpen
    ? {
      body: 'Alternative exercise added. Click to edit.',
      isOpen: true,
    }
    : {
      body: exercise.alternatives.map(e => e.name).join(' '),
    };

  const trigger = (
    <Flex>
      <Tooltip {...tooltipProps} preferPlace="above">
        <S.AlternativesTrigger>
          {exercise.alternatives.length}
        </S.AlternativesTrigger>
      </Tooltip>
    </Flex>
  );

  if (readOnly) return trigger;

  return (
    <Popup
      isOpen={isOpen}
      trigger={trigger}
      setPopupVisible={() => setIsOpen(!isOpen)}
      handleOuterAction={() => setIsOpen(false)}
    >
      <S.Dropdown>
        <Flex
          column
          padding="10px 20px 5px 20px"
          spacing={5}
        >
          <Text
            size="12px"
            color="#999999"
          >
            ALTERNATIVES
          </Text>
          <Flex
            align="center"
            spacing={5}
            clickable
            onClick={() => {
              setIsOpen(false);
              onAdd(exercise.id);
            }}
          >
            <S.PlusCircle />
            <Text
              color="primary"
            >
              ADD ALTERNATIVE
            </Text>
          </Flex>
        </Flex>
        {exercise.alternatives.map(e => (
          <S.Item
            key={e.id}
            onClick={() => {
              onSet(exercise.id, e.id);
              setIsOpen(false);
            }}
          >
            {e.name}
            <S.Remove
              type="button"
              onClick={(ev) => {
                ev.stopPropagation();
                onRemove(e);
                setIsOpen(false);
              }}
            >
              <Icon
                type="fas fa-times"
                color="danger"
              />
            </S.Remove>
          </S.Item>
        ))}
      </S.Dropdown>
    </Popup>
  );
};

export default Alternatives;
